var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indexEdit clearfix",attrs:{"id":"indexEdit"}},[_c('div',{staticClass:"center-box"},[_c('preview',{ref:"Addrobot",attrs:{"type":"map","openMqtt":"1"},on:{"attr":_vm.Addrobot}})],1),_vm._v(" "),_c('AttrBlackboard',{ref:"addrobot",on:{"changeDivSpan":_vm.changeDivSpan}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-016ab1f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapEditor/Preview/rowPreviewMap.vue
// module id = null
// module chunks = 